import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { DfAccountModule } from '@df/account/df-account.module';
export function provideAccount(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(
            DfAccountModule.forRoot({
                navigation: [
                    { icon: 'basket', label: 'Order History', link: '/account/my-orders' },
                    { icon: 'account', label: 'Account Details', link: '/account/edit' },
                    { icon: 'home', label: 'Address Book', link: '/account/address-book' },
                    { icon: 'account', label: 'Sales Contact', link: '/account/sales-contact', trade: true },
                    { icon: 'card', label: 'Payment Methods', link: '/account/payment-methods' },
                    { icon: 'wishlist', label: 'Your Wishlist', link: '/account/wishlist', trade: false },
                    { icon: 'contact', label: 'Information Centre', link: '/account/information-centre', trade: true },
                    {
                        icon: 'download',
                        label: 'Trade Quick Buy',
                        link: '/account/quick-buy',
                        trade: true,
                        isHidden: true
                    },
                    // { icon: 'symbol-list', label: 'Allowed Categories', link: '/account/allowed-categories', trade: true },
                    { icon: 'download', label: 'Stock Level Report', link: '/account/stock-level-report', trade: true },
                    { icon: 'contact', label: 'Refer a Friend', link: '/account/refer-a-friend', stores: ['uk'] }
                ]
            })
        )
    ]);
}
